import "../../App.css";
import { Link, useNavigate } from "react-router-dom";
import { signal } from "@preact/signals-react";
import axios from "axios";
import Appconfig from "../../config/config";
import { useSelector } from "react-redux";

export const eventId = signal("");

const TableRow = ({ row, inplay }) => {
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state?.userInfo?.userdata); // get login user details

  const formatDateString = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };
  function pinmarket(event_id, market_id) {
    if (userInfo) {
      var data = JSON.stringify({
        event_id: event_id,
        market_id: market_id,
        user_id: userInfo._id,
        type: "Match",
      });
      var config = {
        method: "post",
        url: `${Appconfig.apiUrl}favorite/add&removeFavorite`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function (response) {
          console.log("response.data:", response.data);
        })
        .catch(function (error) {});
    } else {
      navigate("/login");
    }
  }
  return (
    <tr className="text-[0.75rem] border-[1px] border-[solid] border-[#c8ced3]">
      <td className="!pl-[10px] !pr-[10px] !py-[2px] w-[60%]">
        {/* <Link to={`/fullMarket/${row.event_id}/${row.event_id}/${row.is_inplay == 'True' ? "Inplay" : "Going Inplay"}`} className='flex flex-wrap gap-x-2 items-center'> */}
        <Link
          to={`/fullMarket/${row.event_id}/${
            row.is_inplay == "True" ? "Inplay" : "Going Inplay"
          }/${formatDateString(row?.open_date)}`}
          className="flex flex-wrap gap-x-2 items-start flex-col content-start"
        >
          <span className="flex items-center gap-x-1 text-[#2789ce] font-bold">
            <img src="/images/icon-in_play.png" />
            {row?.event_name}
          </span>
          <div className="flex gap-1">
            <div className="flex gap-2">
              {row?.is_inplay === "True" && (
                <span className="!text-[12px] font-bold in-play-effect ml-[10px] flex gap-2 items-center">
                  In-Play
                  <div className="bg-[#1876b2] px-[3px] py-[3px] flex items-center justify-center rounded-[3px] h-[16px]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                    >
                      <g fill="none" fillRule="evenodd">
                        <circle cx="6" cy="6" r="6" fill="#4AA2DB" />
                        <path
                          fill="#FFF"
                          d="M6 0a6 6 0 110 12A6 6 0 016 0zm0 1a5 5 0 100 10A5 5 0 006 1z"
                          opacity=".605"
                        />
                        <path fill="#FFF" d="M4 3v6l5-3z" />
                      </g>
                    </svg>
                  </div>
                </span>
              )}
            </div>

            {row?.is_inplay == "False" && (
              <p className="text-[#777777] font-normal ml-[10px]">
                {formatDateString(row?.open_date)}
              </p>
            )}

            <span className="text-white bg-[#0a92a5] text-center italic font-bold rounded-[3px] h-[16px] flex items-center justify-center] mt-[1px]">
              
              {row?.is_fancy == "True" && (
                <>
                <img
                    src="/images/icon-fancy_inplay.png"
                    className="inline-block h-[16px] w-[19px] mr-[2px] rounded-tl-[3px] rounded-bl-[3px]"
                />
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  className="inline-block mr-[2px]"
                >
                  <path
                    d="M9.44 21.32l1.792-8.456h5.628l.504-2.408h-5.628l1.288-6.02h7.252L20.78 2H10.112c-.896 0-1.68.275-2.352.826-.672.55-1.11 1.283-1.316 2.198L3 21.32h6.44z"
                    fill="#C5F6EE"
                    fill-rule="nonzero"
                  />
                </svg>
                </>
              )}
            </span>

            <span className="text-white bg-[#226bc3] text-center italic font-bold rounded-[3px] h-[16px] flex items-center justify-center mt-[1px]">
              {row?.is_bm === "True" && (
                <>
                  <img
                    src="/images/icon-fancy_inplay.png"
                    className="inline-block h-[16px] w-[19px] mr-[2px] rounded-tl-[3px] rounded-bl-[3px]"
                  />

                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    className="inline-block mr-[2px]"
                  >
                    <path
                      d="M15.58 21c.876 0 1.642-.257 2.3-.77.656-.513 1.085-1.195 1.286-2.047l.986-4.487c.091-.348.05-.679-.123-.992A1.722 1.722 0 0019.33 12c.365-.14.699-.365 1-.678.3-.313.497-.644.588-.992l.986-4.513c.2-.852.087-1.534-.342-2.047-.43-.513-1.09-.77-1.985-.77H5.997L2 21h13.58zm-1.096-10.122h-3.942l1.26-5.608h3.942l-1.26 5.608zm-1.752 7.879H8.79l1.26-5.635h3.942l-1.26 5.635z"
                      fill="#CAFCFF"
                      fillRule="nonzero"
                    />
                  </svg>
                </>
              )}
            </span>

            {/* <span className="text-white bg-[linear-gradient(180deg,_#0a92a5_15%,_#076875_100%)] px-[5px] py-[0] text-center italic font-bold rounded-[4px]">
              {row?.is_bm == "True" && `BM`}
            </span> */}
          </div>
        </Link>
      </td>
      {/* <td className='!pl-[10px] !pr-[10px] !py-[2px]'>
                <div className='flex items-center  gap-1'>
                    <span className='text-white bg-[linear-gradient(-180deg,#184438,#000000)] pl-[2px] pr-[4px] py-[0] text-center italic font-bold rounded-[4px]'>{row?.is_bm == 'True' && `BM`}</span>
                    <span className='text-white bg-[linear-gradient(180deg,_#0a92a5_15%,_#076875_100%)] px-[5px] py-[0] text-center italic font-bold rounded-[4px]'>{row?.is_fancy == 'True' && `F`}</span>
                    <span className='text-white bg-[linear-gradient(180deg,_#0a92a5_15%,_#076875_100%)] px-[5px] py-[0] text-center italic font-bold rounded-[4px]'>{row?.is_bm == 'True' && `BM`}</span>
                </div>
            </td> */}
      <td className=""> 
        <div className="flex items-center  justify-center">
          <span className="inline-flex text-[0.688rem] bg-[#72bbef] text-[#1e1e1e] text-center px-[10px] py-[2px] font-bold min-w-[62px] h-[32px] justify-center items-center mx-[1px]">
            3.55
          </span>
          <span className="inline-flex text-[0.688rem] bg-[#faa9ba] text-[#1e1e1e] px-[10px] py-[2px] font-bold min-w-[62px] h-[32px] justify-center items-center mx-[1px]">
            3.6
          </span>
        </div>
      </td>
      <td className="">
        <div className="flex items-center justify-center border-l border-gray-200">
          <span className="inline-flex text-[0.688rem] bg-[#72bbef] text-[#1e1e1e] px-[10px] py-[2px] font-bold min-w-[62px] h-[32px] justify-center items-center mx-[2px]">
            5.2
          </span>
          <span className="inline-flex text-[0.688rem] bg-[#faa9ba] text-[#1e1e1e] px-[10px] py-[2px] font-bold min-w-[62px] h-[32px] justify-center items-center mx-[1px]">
            5.3
          </span>
        </div>
      </td>
      <td className="text-center">
        <div className="flex items-center justify-center border-l border-gray-200">
          <span className="inline-flex text-[0.688rem] bg-[#72bbef] text-[#1e1e1e] px-[10px] py-[2px] font-bold min-w-[62px] h-[32px] justify-center items-center mx-[3px]">
            4.8
          </span>
          <span className="inline-flex text-[0.688rem] bg-[#faa9ba] text-[#1e1e1e] px-[10px] py-[2px] font-bold min-w-[62px] h-[32px] justify-center items-center mx-[0px]">
            5
          </span>
        </div>
      </td>
      {/* <td className="text-center">
        <img
          src="/images/add-pin-s.png"
          className="h-[21px] w-[16px] leading-[15px] m-[5px]"
        />
      </td> */}
      {/* {!inplay && ( */}
        <td className="!py-[3px] text-center ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            color="#7e97a7"
            className="h-[20px] cursor-pointer"
            onClick={() => pinmarket(row.event_id, row.market_id)}
          >
            <path
              fill="currentColor"
              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
            ></path>
          </svg>
        </td>
      {/* )} */}
    </tr>
  );
};

export default TableRow;
